import React, { useState, useEffect, useContext, createContext, Children } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./custom.css";
import EventModal, { categories } from "./EventModal";
import ReadOnlyEventModal from "./ReadOnlyEventModal";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaS } from "react-icons/fa6";
import ScheduleModal from './ScheduleModal';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { styled, css, display, Stack, width } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import { Button } from '@mui/base/Button';
import { LiaAudioDescriptionSolid } from "react-icons/lia";
import { FaLocationDot, FaRegAddressCard, FaHouse } from "react-icons/fa6";
import { MdOutlineRsvp } from "react-icons/md";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LuLink } from "react-icons/lu";
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AddEventButton from "../Intro/AddEventButton";
import { ImCalendar } from "react-icons/im";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { BsClockFill } from "react-icons/bs";
import WarningIcon from '@mui/icons-material/Warning';


const icon = <Checkbox fontSize="small" />;
const checkedIcon = <Checkbox fontSize="small" checked />;
// Function to get city name by event.city
export const getCityNameByEvent = (eventCity, cities) => {
  const city = cities.find(city => city._id === eventCity);
  return city ? city.cityname : null; // Return cityname or null if not found
};
export const renderScheduleWithTime = (startSch, endSch) => {
  if (!startSch || !endSch) return ""; // Handle empty dates

  const startDate = moment(startSch);
  const endDate = moment(endSch);
  const dayDifference = endDate.diff(startDate, "days");

  // If both dates are the same day, include times
  if (startDate.year() === endDate.year() && startDate.month() === endDate.month() && startDate.day() === endDate.day()) {
    return (
      <Box sx={{ fontSize: '1rem', color: 'black' }}>
        <ImCalendar style={{ marginRight: '0.5rem', fontSize: '1.4rem', fontWeight: 'bold' }} />
        <span style={{ fontSize: '1rem' }}>  {startDate.format("MMMM Do YYYY")} </span>
        <BsClockFill style={{ marginLeft: '0.5rem', fontSize: '1.3rem', marginRight: '0.5rem', fontWeight: 'bold' }} />
        <span style={{ fontSize: '1rem' }}>{startDate.format("h:mm a")} - {endDate.format("h:mm a")} </span>
      </Box>);
  } else {
    // If dates are different, return full date-time range
    return (<Box sx={{ fontSize: '1rem', color: 'black' }}>
      <ImCalendar style={{ marginRight: '0.5rem', fontSize: '1.4rem', fontWeight: 'bold' }} />
      <span style={{ fontSize: '1rem' }}> {startDate.format("MMMM Do YYYY, h:mm a")} - </span>
      {/* <ImCalendar style={{ marginRight: '0.5rem' }} /> */}
      <span style={{ fontSize: '1rem' }}> {endDate.format("MMMM Do YYYY, h:mm a")} </span>
    </Box>);
  }
};


// Styled container for responsive design
const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  padding: '0.5rem',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

const SearchButton = styled(Button)(({ theme }) => ({
  padding: '0.5rem 1rem',
  fontSize: '0.7rem',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    width: '100%', // Full width on small screens
  },
}));

const AutocompleteContainer = styled('div')(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    width: '100%', // Full width on small screens
  },
}));

moment.locale("en-GB");
const localizer = momentLocalizer(moment);
const DataContext = createContext();

export default function MyCalendar() {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  // const {schedule_data} = useContext(DetaContext);
  const [eventsData, setEventsData] = useState([]); // Event list
  const [eventloglist, setEventloglist] = useState([]);

  const [upcomingData, setUpcomingData] = useState();
  const [modalEventListData, setModalEventListData] = useState([]);

  const [schDate, setSchDate] = useState({
    startSch: '', endSch: ''
  });
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    // document.body.style.overflow = 'hidden';
    setOpen(true);
  };
  const handleClose = () => {
    // document.body.style.overflow = 'auto';
    setOpen(false);
  };

  const [modalData, setModalData] = useState({
    sch_user: '',
    visible: false,
    isEdit: false,
    isView: false,
    start: null,
    end: null,
    event: null,
    schedule_id: '',
    title: '',
    location: '',
    description: '',
    address: '',
    image: '',
    link: '',
    category: [],
    cities: [],
    rsvp: false,
    overflowcount: 0
  });

  const [isInitialFetchComplete, setIsInitialFetchComplete] = useState(false); // Track initial fetch
  const token = localStorage.getItem("calendar_admin");
  const user_Id = localStorage.getItem("userId");
  const isAdmin = localStorage.getItem('admin_user');
  const adminLvl = localStorage.getItem('admin_lvl');


  const init_modaldata = () => {
    setModalData({
      sch_user: '',
      visible: false,
      isEdit: false,
      isView: false,
      start: null,
      end: null,
      event: null,
      schedule_id: '',
      title: '',
      location: '',
      description: '',
      address: '',
      image: '',
      link: '',
      category: [],
      rsvp: false,
      overflowcount: 0
    })
  }
  useEffect(() => {
    fetchSchedule();
    // if (modalData.visible == false && open == false) 
    {
      document.body.style.overflow = 'auto';
    }
    // init_modaldata();
  }, [modalData]);


  const Backdrop = React.forwardRef((props, ref) => {
    const { open, className, ...other } = props;
    return (
      <div
        className={clsx({ 'base-Backdrop-open': open }, className)}
        ref={ref}
        {...other}
      />
    );
  });

  Backdrop.propTypes = {
    className: PropTypes.string.isRequired,
    open: PropTypes.bool,
  };


  const grey = {
    50: '#F3F6F9', 100: '#E5EAF2', 200: '#DAE2ED', 300: '#C7D0DD', 400: '#B0B8C4', 500: '#9DA8B7', 600: '#6B7A90', 700: '#434D5B', 800: '#303740', 900: '#1C2025',
  };

  const Modal = styled(BaseModal)`
    position: fixed;
    z-index: 1300;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const StyledBackdrop = styled(Backdrop)`
    z-index: -1;
    position: fixed;
    inset: 0;
    background-color: rgb(0 0 0 / 0.5);
    -webkit-tap-highlight-color: transparent;
  `;

  const style = {
    position: "absolute",
    top: "15%",
    // left: "50%",
    transform: "translateX(-50%)", // Center horizontally
    width: "80%", // Use 90% of the viewport width for small screens
    // maxWidth: 1000, // Limit the width for larger screens
    bgcolor: "background.paper",
    boxShadow: 24,
    p: { xs: 2, sm: 4 }, // Adjust padding for small screens
    borderRadius: 2,
  };
  const ModalContent = styled('div')(
    ({ theme }) => css`
      font-family: 'IBM Plex Sans', sans-serif;
      font-weight: 500;
      text-align: start;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 8px;
      overflow-y: hidden;
      background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
      border-radius: 8px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
      box-shadow: 0 4px 12px
        ${theme.palette.mode === 'dark' ? 'rgb(0 0 0 / 0.5)' : 'rgb(0 0 0 / 0.2)'};
       padding: 24px;
      color: ${theme.palette.mode === 'dark' ? grey[50] : grey[900]};
  
      & .modal-title {
        margin: 0;
        line-height: 1.5rem;
        margin-bottom: 8px;
      }
  
      & .modal-description {
        margin: 0;
        line-height: 1.5rem;
        font-weight: 400;
        color: ${theme.palette.mode === 'dark' ? grey[400] : grey[800]};
        margin-bottom: 4px;
      }
    `,
  );


  const setEvent_schedule = (response) => {
    const fetchedEvents = response.data.map((event) => ({
      ...event,
      start: new Date(event.start), // Convert ISO string to Date object
      end: new Date(event.end),     // Convert ISO string to Date object
    }));
    setEventsData(fetchedEvents);
  }

  // Fetch schedule from the server
  const fetchSchedule = async () => {
    // if (!token) return;
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/schedule/fetch/${localStorage.getItem('userId')}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data == 'Empty') {
        toast.warning("Empty events");
      } else {
        setEvent_schedule(response);
      }
    } catch (error) {
      console.error("Error saving schedule:", error.message);
      toast.error("Failed to fetch schedule. Please try again later.");
    }
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get/citynames`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCitiesList(response.data);
    } catch (error) {
      console.error("Error saving schedule:", error.message);
      toast.error("Failed to fetch schedule. Please try again later.");
    }

  };

  // Save schedule to the server
  const sendSchedule = async (schedule_data) => {
    try {
      if (!token) return;

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/schedule/update`,
        { schedule: schedule_data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEvent_schedule(res);
      toast.success("Schedule saved successfully!"); // Toast on success
      handleClose();
    } catch (err) {
      console.error("Error saving schedule:", err.message);
      toast.error("Failed to save schedule. Please try again later.");
    }
    // window.location.reload();
  };

  const getEventList = (allEventData, start, end) => {
    let getEventData;
    let editFlag = false;
    if (start && end) {
      // Convert start and end to Date objects for comparison
      const startDate = new Date(start);
      const endDate = new Date(end);

      // Assuming allEventData is your array of events and user_Id is defined
      getEventData = allEventData
        .map(event => {
          // Determine if the user can edit
          editFlag = user_Id === event.userId;
          isAdmin === 'true' && (editFlag = true)
          // Create a new object containing the event data and the editFlag
          const eventWithEditFlag = { ...event, editFlag };
          return eventWithEditFlag;
        })
        .filter(event => {
          const eventStart = new Date(event.start);
          const eventEnd = new Date(event.end);

          // Check if the event is within the start and end dates
          return (
            (eventStart >= startDate && eventStart < endDate) ||
            (eventEnd > startDate && eventEnd <= endDate) ||
            (eventStart <= startDate && eventEnd >= endDate)
          );
        });

      setSchDate({
        startSch: moment(startDate).format("YYYY-MM-DDTHH:mm"),//moment(startDate).format("MMMM Do YYYY, h:mm a"),
        endSch: moment(endDate).subtract(1, 'seconds').format("YYYY-MM-DDTHH:mm")
      });

    } else {
      // Creating getEventDataNew with editFlag
      editFlag = user_Id === allEventData.userId;
      isAdmin === 'true' && (editFlag = true)
      getEventData = {
        ...allEventData,
        editFlag: editFlag, // Add editFlag to the event object
      };
      getEventData = [getEventData];
      setSchDate({
        startSch: moment(allEventData.start).format("YYYY-MM-DDTHH:mm"),//moment(allEventData.start).format("MMMM Do YYYY, h:mm a"),
        endSch: moment(allEventData.end).format("YYYY-MM-DDTHH:mm")//moment(allEventData.end).format("MMMM Do YYYY, h:mm a"),
        // endSch: moment(allEventData.end).subtract(1, 'seconds').format("YYYY-MM-DDTHH:mm")
      });
    }
    eventSaveLog(getEventData);
    setModalEventListData(getEventData);
    // setUpcomingData(getEventData);
    // isAdmin != 'true' && 
    !(!token && getEventData.length == 0) && handleOpen();
    return getEventData;
  };

  useEffect(() => {

    if (Object.keys(eventloglist).length === 0) {
    } else {
      modalEventListData.forEach(element => {
        if (isAdmin == 'true') {
          element.logData = eventloglist[element._id]; // Add logData to the element
        }
      });
      setModalEventListData(modalEventListData);
    }
    // console.log(`--${JSON.stringify(modalEventListData, null, 2)}`)
    isAdmin == 'true' && schDate.startSch != '' && handleOpen();
  }, [eventloglist]);


  //save eventlog when event clicked
  // Function to save event log data
  const eventSaveLog = async (event) => {
    let senddata = {
      eventId: [],
      visiter_Id: user_Id || null,
    };

    event.forEach(element => {
      // Push the event ID into the eventId array
      if (element._id) {
        senddata.eventId.push(element._id);
      }
    });
    if (senddata.eventId.length == 0) return;
    try {
      // Send the log data to the API
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/eventlog/save/`,
        { senddata },
      );
      setEventloglist(response.data); // Store the result

      return response.data; // Return the response data
    } catch (error) {
      console.error('Error saving event log:', error);
      throw error; // Rethrow the error for further handling
    }
  };

  // Open modal to create a new event
  const handleSelectSlot = ({ start, end }) => {
    // console.log(start,end);
    if (!start || !end) return; // Guard clause to prevent undefined values
    getEventList(eventsData, start, end);
  };

  // Function to format date
  function formatDate(dateString, time) {

    
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day} ${time}`;
  }

  // Open modal to edit an existing event

  const handleSelectEvent = (event) => {

    const isMobile = window.innerWidth < 600; // Check if screen width is below 600px
    if (!event) return; // Guard clause to prevent undefined event
    if (isMobile) {
      // console.log(formatDate(event.start, '00:00'), formatDate(event.end, '23:59'));
      // getEventList(eventsData, formatDate(event.start, '00:00'), formatDate(event.end, '23:59'));
    }
    else { getEventList(event); }
  };

  // Save or update an event
  const handleSave = (newEvent) => {

    sendSchedule(newEvent);
    setModalData(prev => ({ ...prev, visible: false, isEdit: false, start: null, end: null, event: null }));
  };


  // Delete an event
  const handleDelete = async (eventId) => {
    if (!token) return;
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/schedule/delete/${eventId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // Update the events data state to remove the deleted event
      const updatedEventsData = eventsData.filter(event => event._id !== eventId);
      setEventsData(updatedEventsData); // Set the updated events data to state
      // setEventsData(eventsData);
      toast.info("Event deleted successfully!"); // Toast on delete
    } catch (error) {
      console.error("Error saving schedule:", error.message);
      toast.error("Failed to fetch schedule. Please try again later.");
    }
    setModalData(prev => ({ ...prev, visible: false }));
    handleClose();
    // window.location.reload();
  };

  const areSameDay = (start, end) => {
    const start1 = new Date(start)
    const start2 = new Date(end)
    // Calculate the time difference in milliseconds
    const timeDifference = start2 - start1;
    // One day in milliseconds
    const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
    return (
      start1.getFullYear() === start2.getFullYear() &&
      start1.getMonth() === start2.getMonth() &&
      start2.getDay() === start1.getDay()
    );
  };

  // Define event colors based on the category
  const eventStyleGetter = (event) => {
    // const { overflowCount, totalOverlappingCount, sortIndex } = calculateOverflowAndSortIndex(eventsData, event);

    let backgroundColor = categories[event.selectedCategory[0]]['color'];
    let color = 'white';
    if (areSameDay(event.start, event.end)) {
      backgroundColor = 'white';
      color = 'gray';
    }
    if (event.approve != true) backgroundColor = '#cdcdcd';
    return {
      style: {
        backgroundColor,
        color, // Set text color to white for contrast
        borderRadius: "2px",
        // padding: "3px",
      },
    };
  };

  const getTimeFromStartDay = (StartDay) => {
    let StartDay1 = new Date(StartDay);
    const hr = StartDay1.getHours() < 10 ?
      `0${StartDay1.getHours()}` : `${StartDay1.getHours()}`;
    const min = StartDay1.getMinutes() < 10 ?
      `0${StartDay1.getMinutes()}` : `${StartDay1.getMinutes()}`;
    return `${hr}:${min}`;
    ;
  }

  const show_event_style = (event) => {
    const isMobile = window.innerWidth < 600; // Check if screen width is below 600px
    const oneday_event = areSameDay(event.start, event.end);

    return (
      <div style={{ boxShadow: "0 14px 16px rgba(0, 0, 0, 0.1)", alignItems: "center" }}>
        <div>
          {isMobile ? (
            // Render a colored dot and wrapped title for mobile
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{
                display: 'inline-block',
                width: '0.7rem', // Set width for dot
                height: '0.7rem', // Set height for dot
                borderRadius: '50%', // Make it a circle
                backgroundColor: categories[event.selectedCategory[0]]['color'], // Dot color
                // marginRight: '5px' // Space between dot and text
              }} />
              {/* <span style={{
                color: oneday_event ? categories[event.selectedCategory[0]]['color'] : 'white',
                // whiteSpace: 'nowrap', // Prevent wrapping
                // overflow: 'hidden', // Hide overflow text
                textOverflow: 'ellipsis', // Add ellipsis for overflow
                // maxWidth: '150px', // Set a max width for the title
                display: 'block', // Ensure it behaves like a block element
                fontSize: '0.7rem', padding: '0 0', margin: '0 0'
              }}>
                {oneday_event && getTimeFromStartDay(event.start)}&nbsp;{event.title}
              </span> */}
            </span>
          ) : (
            // Original rendering for larger screens
            <span style={{
              margin: '0px 0px 0px 0px',
              fontSize: '1rem',
              color: oneday_event ? categories[event.selectedCategory[0]]['color'] : "white"
            }}>
              {event.selectedCategory.map((item, index) => (
                <span key={index} style={{
                  color: oneday_event ? categories[item]['color'] : "white"
                }}>
                  {categories[item]['icon']}&nbsp;
                </span>
              ))}
              <span style={{ margin: '0 0 0 0' }}>
                <span style={{ color: categories[event.selectedCategory[0]]['color'] }}>
                  {oneday_event && getTimeFromStartDay(event.start)}
                </span>
                &nbsp;{event.title}
              </span>
            </span>
          )}
        </div>
      </div>
    );
  }

  const setEditModal = (flag, event) => {
    // document.body.style.overflow = 'hidden';
    switch (flag) {
      case 'create':
        setModalData({
          sch_user: user_Id,
          start: schDate.startSch,
          end: schDate.endSch,
          visible: true,
          isEdit: false,
          isView: false,
          scheduleId: "",
          title: "",
          location: "",
          description: "",
          address: "",
          cimage: "",
          link: "",
          category: "",
          cities: "",
          rsvp: false,
          event: null
        });
        break;
      case 'view':
        setModalData({
          sch_user: event.userId,
          visible: true,
          isEdit: false,
          isView: true,
          start: moment(event.start).format("YYYY-MM-DDTHH:mm"),
          end: moment(event.end).format("YYYY-MM-DDTHH:mm"),
          scheduleId: event._id,
          title: event.title,
          location: event.location,
          description: event.description,
          address: event.address,
          cimage: event.cimage,
          link: event.link,
          category: event.selectedCategory,
          cities: event?.city,
          rsvp: event.rsvp,
          event: null
        });
        break;
      case 'edit':
        setModalData({
          sch_user: event.userId,
          visible: true,
          isEdit: true,
          isView: false,
          start: moment(event.start).format("YYYY-MM-DDTHH:mm"),
          end: moment(event.end).format("YYYY-MM-DDTHH:mm"),
          scheduleId: event._id,
          title: event.title,
          location: event.location,
          description: event.description,
          address: event.address,
          cimage: event.cimage,
          link: event.link,
          cities: event?.city,
          category: event.selectedCategory,
          rsvp: event.rsvp,
          event: null,
        });
        break;
      case 'delete':
        break;
      default:
        break;

    }
  }

  /////////////////////search component//////////////////////////////////
  const handleCategoryChange = (event, value) => {
    setSelectedCategories(value); // Set categories only if none are selected
  };

  const handleCityChange = (event, value) => {
    setSelectedCities(value.map(city => city._id));
  };

  const handleSearch = async () => {
    // Implement your search logic here
    if (selectedCategories.length === 0 && selectedCities.length === 0) {
      fetchSchedule();
      return;
    }

    try {
      // Send the log data to the API
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/filter/`,
        {
          categories: selectedCategories,
          cities: selectedCities
        },
      );
      setEvent_schedule(response); // Store the result
      // return response.data; // Return the response data
    } catch (error) {
      console.error('Error search:', error);
      throw error; // Rethrow the error for further handling
    }
  };
  function CheckboxesTags() {
    return (
      <Container>
        <AutocompleteContainer>
          <Autocomplete
            multiple
            id="checkboxes-categories"
            options={Object.keys(categories)}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            onChange={handleCategoryChange}
            value={selectedCategories} // Set the value to the selected categories
            limitTags={3} // Limit to 2 displayed tags
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              const { icon, color } = categories[option];
              return (
                <li key={key} {...optionProps} style={{ display: 'flex', alignItems: 'center', fontSize: '0.8rem' }}>

                  <span style={{ color }}>{option}</span>
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField {...params} label="Categories" placeholder="Search" />
            )}
          />
        </AutocompleteContainer>
        {citiesList?.length > 0 && (
          <AutocompleteContainer>
            <Autocomplete
              multiple
              id="checkboxes-cities"
              options={citiesList}
              disableCloseOnSelect
              getOptionLabel={(option) => option.cityname}
              onChange={handleCityChange} // Updated handler
              value={citiesList?.filter(city => selectedCities?.includes(city._id))} // Filter to show selected city objects
              limitTags={3}
              renderOption={(props, option, { selected }) => {
                return (
                  <li {...props} style={{ fontSize: '0.8rem' }}>

                    {option.cityname}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField {...params} label="Cities" placeholder="Select cities" />
              )}
            />
          </AutocompleteContainer>
        )}

        {/* Search Button */}
        <SearchButton onClick={handleSearch}>
          <ManageSearchIcon />
        </SearchButton>
      </Container>
    );
  }


  const renderSchedule = (startSch, endSch) => {
    if (!startSch || !endSch) return ""; // Handle empty dates

    const startDate = moment(startSch);
    const endDate = moment(endSch);
    const dayDifference = endDate.diff(startDate, "days");

    if (dayDifference === 0) {
      return startDate.format("MMMM Do YYYY"); // Return single date
    } else if (dayDifference === 1) {
      return `${startDate.format("MMMM Do YYYY")} - ${endDate.format("MMMM Do YYYY")}`; // Return range for 2 days
    } else {
      return `${startDate.format("MMMM Do YYYY")} - ${endDate.format("MMMM Do YYYY")}`; // Return full range
    }
  };

  const customMessages = {
    agenda: 'List View',
    // Add other custom messages if needed
  };

  const onShowMore = (events, date) => {
    const isMobile = window.innerWidth < 600; // Check if screen width is below 600px
    if (isMobile) {
      getEventList(events, date, date);
      // console.log(events, date);
    }
  }

  const eventPopoverContent = (event) => (
    <div style={{ width: '80%' }}>
      {/* Your custom popover content */}
      <h3>{event.title}</h3>
      <p>{event.start.toLocaleString()} - {event.end.toLocaleString()}</p>
      {/* Add any other content you want to display */}
    </div>
  );
  const addEvent = () => {
    const today = new Date();
    const daystart = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0).toISOString().slice(0, 16);
    const dayend = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, 0, 0, 0).toISOString().slice(0, 16);
    // handleSelectSlot(daystart, dayend);
    getEventList(eventsData, daystart, dayend);
  }
  return (
    <Stack style={{ width: '100%' }}>

      <div className="calendar">
        <ToastContainer
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
          toastClassName="custom-toast"
        />
        {/* <DataProvider> */}
        <CheckboxesTags />
        {token && <span onClick={addEvent}><AddEventButton ></AddEventButton></span>}
        <Calendar
          selectable
          localizer={localizer}
          defaultDate={new Date()}
          defaultView="month"
          events={eventsData}
          style={{ height: "100vh" }}
          onSelectSlot={handleSelectSlot}
          onSelectEvent={handleSelectEvent}
          views={['month', 'week', 'day', 'agenda']} // Agenda will be renamed to List View
          messages={customMessages} // Custom messages
          eventPropGetter={eventStyleGetter} // Pass the eventStyleGetter to apply colors
          onShowMore={onShowMore}
          eventPopoverContent={eventPopoverContent}
          popup={true}

          // Displaying the event title directly
          components={{
            event: ({ event }) => (
              show_event_style(event)
            ),
          }}
        />

        <div>
          <Button onClick={handleOpen} style={{ display: 'none' }}>Open modal</Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
            slots={{ backdrop: StyledBackdrop }}
            style={{ overflowY: 'auto' }}
          >
            <div>
              <div>

              </div>
              <ModalContent sx={style}>
                <div>
                  <div style={{ display: "flex", justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '1rem' }}>
                      {/* {schDate.startSch != '' && moment(schDate.startSch).format("MMMM Do YYYY")} - {schDate.endSch != '' && moment(schDate.endSch).format("MMMM Do YYYY")} */}
                      {renderSchedule(schDate.startSch, schDate.endSch)}
                    </span>
                    {
                      token &&
                      <Fab size="small" color="secondary" aria-label="add" onClick={() => setEditModal('create')}>
                        <AddIcon />
                      </Fab>
                    }
                  </div>
                  <div>
                    {(modalEventListData || []).map((event) => {
                      const isSingleEvent = modalEventListData.length === 1;  // Check if there's only one event

                      return (
                        <div key={event._id} className="" style={{ width: '100%' }}>
                          <Accordion
                            expanded={isSingleEvent || expanded === `${event._id}`} // If it's a single event, expand it by default
                            onChange={handleChange(`${event._id}`)}
                            sx={{ justifyContent: 'center', justifySelf: 'center', width: '100%' }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              sx={{ justifyContent: "space-between", justifySelf: 'center', width: '100%' }}
                            >
                              <Typography sx={{
                                width: '100%',
                                flexShrink: 0,
                                overflowY: 'hidden', // Hide overflow
                                whiteSpace: 'wrap', // Prevent wrapping
                                textOverflow: 'ellipsis', // Show ellipsis
                              }}>
                                <b>{event.title}</b> {event.rsvp && <MdOutlineRsvp style={{ fontSize: '25px', color: 'green' }} />}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                              sx={{
                                justifyContent: "space-between",
                                justifySelf: 'center',
                                width: '100%',
                              }}
                            >

                              <Box
                                sx={{
                                  margin: '0 auto',
                                  padding: { xs: '0rem 0.5rem 0rem 0.5rem', md: '0rem 1rem 0rem 1rem' },
                                  display: 'flex',
                                  flexDirection: { xs: 'column', md: 'row' },
                                  gap: '1.5rem',
                                  maxWidth: '1200px', // Limit the maximum width for larger screens
                                  alignItems: 'stretch', // Ensures all children have the same height
                                }}
                              >
                                {/* Event Details */}
                                <Box
                                  sx={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.5rem',
                                    justifyContent: 'space-between', // Distribute content evenly within the box
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    {/* Additional event info */}
                                  </Box>
                                  <Box  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    height: '100%',
                                  }}>
                                    {event.cimage && (
                                      <img
                                        src={event.cimage}
                                        alt="Event"
                                        style={{ width: '100%', maxWidth: '20rem', borderRadius: '8px' }}
                                      />
                                    )}
                                  </Box>

                                </Box>

                                {/* Details Box */}
                                <Box
                                  sx={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.5rem',
                                    fontSize: '1rem',
                                    backgroundColor: '#f9f9f9',
                                    padding: '1rem',
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                    justifyContent: 'space-between', // Ensure spacing between child elements
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                    <span className="todo-dates" style={{ color: 'gray' }}>
                                      {renderScheduleWithTime(event.start, event.end)}
                                    </span>
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                    <FaHouse className="icon" />
                                    <span style={{ marginLeft: '0.5rem' }}>{event.location}</span>

                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                    <FaLocationDot className="icon" />
                                    <span style={{ marginLeft: '0.5rem' }}>{event.address}</span>
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                    <LocationCityIcon className="icon" />
                                    <span style={{ marginLeft: '0.5rem' }}>{getCityNameByEvent(event?.city, citiesList)}</span>
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                    <Link
                                      href={`${event.link.startsWith('http://') || event.link.startsWith('https://') ? '' : 'https://'}${event.link}`}
                                      target="_blank"
                                      fontSize={'1rem'}
                                      sx={{ color: 'primary.main', textDecoration: 'underline' }}
                                    >
                                      {event.link}
                                    </Link>
                                  </Box>
                                  <Box sx={{ fontSize: '1rem', textWrap: 'wrap', flex: 1 }}>
                                    {event.description}
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-start",
                                      gap: "0.5rem",
                                      flex: 1,
                                    }}
                                  >
                                    {event.rsvp && <span style={{
                                      fontSize: '1rem',
                                      color: 'gray',
                                      border: '1px solid #ccc', // Light gray border
                                      padding: '0.1rem 0.5rem',    // Padding inside the rectangle
                                      borderRadius: '8px',       // Rounded corners (optional)
                                      display: 'inline-block',    // Makes the span behave like a block element, allowing padding and border to apply
                                    }}>
                                      {/* {event.rsvp && <MdOutlineRsvp style={{ fontSize: '2rem', color: 'green' }} />} */}
                                      RSVP required
                                    </span>}
                                    {event.selectedCategory.map((item, index) => (
                                      <span
                                        key={index}
                                        style={{
                                          color: categories[item]['color'],
                                          fontSize: '1rem',
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {categories[item]['icon']}&nbsp;
                                        <span>{item}</span>
                                      </span>
                                    ))}
                                  </Box>
                                </Box>
                              </Box>

                              {event.approve != true &&
                                <div style={{ display: 'flex', alignItems: 'center', color: 'orange', fontWeight: 'bold', margin: '10px 0', placeContent: 'center' }}>
                                  <WarningIcon style={{ marginRight: '0.5rem' }} />
                                  <Typography variant="body1" sx={{ placeContent: 'center' }}>
                                    This event is pending approval by site administrators, and isn’t visible to visitors yet.
                                  </Typography>
                                </div>}
                              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>

                                {isAdmin === 'true' && event?.logData && (
                                  <>
                                    <Box
                                      sx={{
                                        backgroundColor: '#282c34',  // Dark background for a modern look
                                        color: '#61dafb',            // Light blue text color for counts
                                        padding: '15px',             // Padding around the text
                                        borderRadius: '8px',         // Rounded corners
                                        margin: '10px 0',            // Margin for spacing
                                        fontFamily: 'Arial, sans-serif', // Modern font
                                        textAlign: 'center',
                                        display: 'flex',             // Default to flex for web
                                        flexDirection: { xs: 'column', sm: 'row' }, // Stack items on small screens, row on larger
                                        justifyContent: 'center',     // Center items horizontally
                                        alignItems: 'center',        // Center items vertically
                                        fontSize: { xs: '14px', sm: '16px' }, // Smaller font size for mobile
                                      }}
                                    >
                                      <Box sx={{ display: 'flex' }}>

                                        <Box sx={{ display: 'flex', alignItems: 'center', margin: '5px 0' }}>
                                          <span style={{ fontWeight: 'bold', color: 'gray' }}>Today:</span>
                                          <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{event?.logData?.today}</span>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', margin: '5px 0' }}>
                                          <span style={{ marginLeft: '15px', fontWeight: 'bold', color: 'gray' }}>This Week:</span>
                                          <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{event?.logData?.week}</span>
                                        </Box>
                                      </Box>
                                      <Box sx={{ display: 'flex' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', margin: '5px 0' }}>
                                          <span style={{ marginLeft: '15px', fontWeight: 'bold', color: 'gray' }}>This Month:</span>
                                          <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{event?.logData?.month}</span>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', margin: '5px 0' }}>
                                          <span style={{ marginLeft: '15px', fontWeight: 'bold', color: 'gray' }}>Overall:</span>
                                          <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{event?.logData?.overall}</span>
                                        </Box>
                                      </Box>
                                    </Box>
                                  </>
                                )}

                                <Typography sx={{ gap: '15px' }}>
                                  {event.editFlag && token && (
                                    <Fab color="secondary" aria-label="edit" size="small" onClick={() => setEditModal('edit', event)}>
                                      <EditIcon />
                                    </Fab>
                                  )}
                                </Typography>
                              </Box>
                            </AccordionDetails>

                          </Accordion>
                        </div>
                      );
                    })}


                  </div>
                </div>
              </ModalContent>

              {modalData && modalData.visible && (
                // modalData.isView ?
                //   <ReadOnlyEventModal 
                //     modalData={modalData}
                //     onSave={handleSave}
                //     onClose={() => setModalData({ visible: false, isEdit: false })}
                //     onDelete={handleDelete}
                //   />
                //   :
                <EventModal
                  modalData1={modalData}
                  onSave={handleSave}
                  onClose={() => setModalData(prev => ({ ...prev, visible: false, isEdit: false }))}
                  onDelete={handleDelete}
                  citylist={citiesList}
                />
              )}

            </div>

          </Modal>

        </div >
        < hr ></hr >
      </div >
    </Stack>

  );
}
